module.exports = __webpack_public_path__ + "static/media/product-10.b0c46348.jpg";